export enum ProjectStatus {
	MISSING_VALUE = "MISSING_VALUE",
	ACTIVE = "ACTIVE",
	OFFER = "OFFER",
	REJECTED = "REJECTED",
	COMPLETED = "COMPLETED",
	WARRANTY = "WARRANTY",
	NOT_RELEVANT = "NOT_RELEVANT",
}
